// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://skdignrsplwwxoiulvdb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNrZGlnbnJzcGx3d3hvaXVsdmRiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY1OTMxOTMsImV4cCI6MjA1MjE2OTE5M30.uMH-MKGCmhbvQKNafPiTQYW__URIOjnGHtL5gAKPYsA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);